/**
 * Request options for a direct browser -> IDV multipart upload.
 *
 * Extracted from the axios call so the security-relevant decisions can be
 * asserted on their own:
 *
 *  - Content-Type is deliberately absent, so the browser generates the
 *    multipart boundary. Setting it by hand produces an unparsable body.
 *  - withCredentials is false: this is a cross-origin call to a different
 *    service, authenticated by a bearer token. No Certage cookie may go with it.
 *  - The FormData is passed through untouched: no serialisation, no base64.
 */
export function buildFormRequestOptions(formData, token) {
  return {
    method: 'POST',
    timeout: 120000,
    withCredentials: false,
    data: formData,
    ...(token && { headers: { Authorization: `Bearer ${token}` } }),
  };
}
